import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleTableComponent } from './simple-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
// import { CodeHighlighterModule } from 'primeng/codehighlighter';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
// import { SliderModule } from 'primeng/components/slider/slider';
import { CalendarModule } from 'primeng/calendar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { CheckboxModule } from 'primeng/checkbox';
import { PipeModule } from 'src/app/pipes/pipe.module';
import { BotonesActionModule } from '../../botones/botones.module';

@NgModule({
    declarations: [
        SimpleTableComponent,
        
    ],
    imports: [ 
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ToastModule,
        ButtonModule,
        TabViewModule,
        TableModule,
        DialogModule,
        DropdownModule,
        InputTextModule,
        MultiSelectModule,
        CalendarModule,
        RadioButtonModule,
        InputSwitchModule,
        ConfirmDialogModule,
        CheckboxModule,
        PipeModule,
        
        BotonesActionModule,
    
     ],
    exports: [SimpleTableComponent],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SimpleTableModule {}